import {useProject} from "../Context/ProjectContext";
import EmptyLine from "./EmptyLine";

export default function FilterText({type}) {
    const {filter, setFilter} = useProject()

    const getFilter = () => {
        let _filter = {}
        if(type === 'check') {
            _filter = {...filter.check, filterType: filter.filterType}
        }
        else {
            _filter = {...filter.comparison, filterType: filter.filterType}
        }

        if(!_filter.us && !_filter.ds) {
            return {filterType: 'none'}
        }

        return _filter
    }

    return (
        <>
            {
                getFilter().filterType === 'highlight' && (
                    <div>
                        The findings within the selected Project Reach [{getFilter().ds} – {getFilter().us}] are highlighted with <text style={{color: '#00a8ff', fontWeight: 'bold'}}>blue</text> color.
                        <EmptyLine />
                    </div>
                )
            }
            {
                getFilter().filterType === 'filter' && (
                    <div>
                        The following are the filtered findings within the selected Project Reach [{getFilter().ds} – {getFilter().us}].
                        <EmptyLine />
                    </div>
                )
            }
        </>
    )
}